import { useMutation } from '@tanstack/react-query';
import { postReviewRequest, type ReviewRequestResult } from '@/lib/api';

interface ReviewRequestVariables {
  contactId: string;
}

/**
 * useReviewRequest — fires the GHL workflow that texts the customer a review link.
 *
 * IRREVERSIBLE: triggers a real outbound SMS. The caller (ActionGrid) MUST
 * confirm with a ConfirmDialog before invoking mutate(). This hook itself
 * does not gate; that's intentional so we can compose with any UI confirm.
 */
export function useReviewRequest(slug: string) {
  return useMutation<ReviewRequestResult, Error, ReviewRequestVariables>({
    mutationFn: ({ contactId }) => postReviewRequest(contactId, slug),
  });
}
